// extracted by mini-css-extract-plugin
export var active = "_h8-7";
export var blink = "_h8-8";
export var dropDownSelector = "_h8-4";
export var dropDownWrapper = "_h8-3";
export var fakeCursor = "_h8-6";
export var fontSizeButton = "_h8-9";
export var formQuillEditor = "_h8-0";
export var pressed = "_h8-a";
export var qlBlank = "_h8-1";
export var textFormattingToolbar = "_h8-2";
export var textToolbarOption = "_h8-5";